<template>
  <button class="base-button">
    <img src="@/assets/icons/Close.svg" alt="" class="icon-close" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CloseButton",
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/closeButton";
</style>
